import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from '../styles';
import { translate } from '../translate';

export const ContactBox = ({ contact }) => (
  <View style={styles.box}>
    <Text style={styles.rowHeader}>{translate('yourContact')}</Text>
    <Text style={{}}>{contact.name}</Text>
    {contact.phone && <Text>{contact.phone}</Text>}
    {contact.email && <Text>{contact.email}</Text>}
  </View>
);
